import Vue from 'vue';
import Vuex from 'vuex';
import snacks from './modules/snack';
import user from './modules/user';
import page from './modules/page';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    snacks: snacks,
    user: user,
    page: page
  }
});